<template>
  <div>
    <MailTemplateConditionsComponent class="mb-2" @changeConditions="changeConditions" />

    <div>
      <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
      <b-table striped hover fixed Outlined show-empty
        select-mode="single"
        selectable
        @row-selected="selected = $event[0] || null"
        :items="templates"
        :fields="fields"
        :empty-text="'No data available'"
        :table-class="'list-table text-center'"
        :thead-class="'list-table__head'"
        :tbody-class="'list-table__body'"
      />
    </div>

    <div v-if="selected">
      <div class="row">
        <div class="col form-group">
          <label>Subject</label>
          <div>{{ selected.subject }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col form-group">
          <label>Mail text</label>
          <div style="white-space:pre-wrap;">{{ selected.body }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      Not selected template
    </div>

    <div class="d-flex justify-content-end">
      <b-button pill variant="primary" @click="next">
        Next
      </b-button>
    </div>

    <loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { MailTemplate, MailTemplateConditions, MailTemplatesState } from '@/store/mails/templates/types'
import { MailNotifications, mailNotificationType } from '@/store/mails/types'
import { University } from '@/store/master/types'
import MailTemplateConditionsComponent from '@/components/parts/mails/sendBulk/MailTemplateConditions.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import PagerComponent from '@/components/parts/Pager.vue'
import { Pager } from '@/store/pager.types'

type modeType = 'student'

@Component({
  components: {
    MailTemplateConditionsComponent,
    Loading,
    PagerComponent,
  },
})
export default class MailsSendBulkSelectMailTemplate extends Vue {
  @Prop() value!: MailTemplate|null

  @Prop({ required: true }) mode!: modeType

  private isLoading: boolean = false

  private conditions: MailTemplateConditions = {
    name: null,
    month: null,
    targets: [this.mode],
  }

  private fields = [
    {
      key: 'university',
      label: 'University',
      formatter: (u: University): string => u.name,
    },
    {
      key: 'notification',
      label: 'Type',
      formatter: (t: mailNotificationType): string => MailNotifications[t],
    },
    {
      key: 'month',
      label: 'Month',
    },
    {
      key: 'name',
      label: 'Name',
    },
  ]

  private get templates(): MailTemplate[] {
    return (this.$store.state.mails.templates as MailTemplatesState).templates
  }

  private get pager(): Pager {
    return (this.$store.state.mails.templates as MailTemplatesState).pager
  }

  private created(): void {
    this.search()
  }

  /**
   * メールテンプレートを検索
   */
  private search(page: number = 1): void {
    if (this.isLoading) {
      return
    }
    this.isLoading = true
    this.$store.dispatch('fetchMailTemplates', { conditions: this.conditions, page })
      .finally(() => { this.isLoading = false })
  }

  /**
   * メールテンプレート検索条件変更
   */
  private changeConditions(conditions: MailTemplateConditions): void {
    this.conditions = {
      targets: [this.mode],
      ...conditions,
    }
    this.search()
  }

  /**
   * ページ変更
   */
  private changePage(page: number): void {
    this.search(page)
  }

  private get selected(): MailTemplate|null {
    return this.value || null
  }

  private set selected(template: MailTemplate|null) {
    this.$emit('input', template)
  }

  private next() {
    if (this.selected) {
      this.$emit('next')
    } else {
      this.$bvModal.msgBoxOk('Please select mail template')
    }
  }
}
</script>

<style>

</style>
